/**
 * Shared constants for gift link functionality
 */

export const GIFT_TARGET_ROUTES = [
  "/analysis/",
  "/articles/",
  "/instant-intel/",
  "/questions-and-answers/",
  "/trend-setters/",
];

export const isGiftTargetRoute = (pathname: string): boolean =>
  pathname
    ? GIFT_TARGET_ROUTES.some((route) => pathname.includes(route))
    : false;

export const hasGiftParams = (query: { t?: string; h?: string }): boolean =>
  !!(query.t && query.h);

export type GiftQueryParams = { t?: string; h?: string };
